// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-container {
  height: 36px;
}
.button-container button {
  cursor: pointer;
  width: 100%;
  height: 100%;
  border: 1px solid #006de9;
  border-radius: 10px;
  font-size: 14px;
  line-height: 21px;
}
.button-container button:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}
.button-container button:focus-visible {
  outline: 2px solid black;
}
.button-container-primary button {
  color: white;
  background-color: #006de9;
}
.button-container-secondary button {
  color: #006de9;
  background-color: white;
}
/*# sourceMappingURL=index.css.map */`, "",{"version":3,"sources":["webpack://./index.less","webpack://./src/components/shared/button/index.less"],"names":[],"mappings":"AAEA;EACE,YAAA;ACDF;ADAA;EAII,eAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;ACDJ;ADEI;EACE,mBAAA;EACA,YAAA;ACAN;ADEI;EACE,wBAAA;ACAN;ADIE;EAEI,YAAA;EACA,yBAAA;ACHN;ADOE;EAEI,cAAA;EACA,uBAAA;ACNN;AACA,oCAAoC","sourcesContent":["@import '../../../style/colors.less';\n\n.button-container {\n  height: 36px;\n\n  button {\n    cursor: pointer;\n    width: 100%;\n    height: 100%;\n    border: 1px solid @BgBorderBrand;\n    border-radius: 10px;\n    font-size: 14px;\n    line-height: 21px;\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.4;\n    }\n    &:focus-visible {\n      outline: 2px solid black;\n    }\n  }\n\n  &-primary {\n    button {\n      color: white;\n      background-color: @BgBorderBrand;\n    }\n  }\n\n  &-secondary {\n    button {\n      color: @BgBorderBrand;\n      background-color: white;\n    }\n  }\n}\n",".button-container {\n  height: 36px;\n}\n.button-container button {\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #006de9;\n  border-radius: 10px;\n  font-size: 14px;\n  line-height: 21px;\n}\n.button-container button:disabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n}\n.button-container button:focus-visible {\n  outline: 2px solid black;\n}\n.button-container-primary button {\n  color: white;\n  background-color: #006de9;\n}\n.button-container-secondary button {\n  color: #006de9;\n  background-color: white;\n}\n/*# sourceMappingURL=index.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
